import Cookies from 'universal-cookie';
import styles from './Filters.module.css';

const cookies = new Cookies();

function Filters({event, 
    onNameChange,
    onDivChange,
    onTypeChange,
    divFilter,
    nameFilter,
    typeFilter})
    {
    
    /* Event handlers */
    const handleTypeChange = function (e) {
        onTypeChange(e.target.value);  
        cookies.set('entry_type_filter', e.target.value);      
    }

    const handleNameChange = function (e) {
        onNameChange(e.target.value);
    }

    const handleDivChange = function (e) {
        onDivChange(e.target.value);
        cookies.set('division_filter', e.target.value);
    }

    if (!event) return null;

    return (
               
            <div className="filters"><span style={{fontWeight: 'bold'}}>Filter by. . .</span>
                {
                event.divisions && event.divisions.length > 1 &&
                <>
                    <div>Division:</div>
                        {event.divisions.map((v) => {
                            return <div className="form-check form-check-inline">
                                    <input className="form-check-input" type="radio" name="divr" value={v} onChange={handleDivChange} checked={divFilter === v} id={`${v}radio`}/>
                                    <label className="form-check-label" htmlFor={`${v}radio`}>{v}</label>
                                </div>
                        })
                        }
                        
                    
                </>
                }
                <div className={styles.formWrap}>
                    <div>Entry Type:</div>
                    <div className="col-md-4">
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="typef" value="All" onChange={handleTypeChange} checked={typeFilter === 'All'} id="allradio" />
                            <label className="form-check-label" htmlFor="allradio">All</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="typef" value="Individual" onChange={handleTypeChange} checked={typeFilter === 'Individual'} id="indradio" />
                            <label className="form-check-label" htmlFor="indradio">Individuals</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="typef" value="Pair" onChange={handleTypeChange} checked={typeFilter === 'Pair'} id="pradio" />
                            <label className="form-check-label" htmlFor="pradio">Pairs</label>
                        </div>
                    </div>
                </div>
                <div className={styles.formWrap}>
                    <label className="form-label">Name:</label>
                        
                            <input type="text" name="namefilter" value={nameFilter} onChange={handleNameChange} className="form-control" />
                
                </div>

            </div>
        
    )
}

export default Filters;